// extracted by mini-css-extract-plugin
export default {"main":"styles_main__NnQaK","main_container":"styles_main_container__9awZz","actions_container":"styles_actions_container__dkq7k","supplier_tag":"styles_supplier_tag__q+IDE"};